import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewEgresoCombustible = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'egreso_combustible',
        name: 'Egreso Combustible',
        component: ViewEgresoCombustible,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
